/* global Image */
import React, { Component } from 'react'
import './Account.css'
import { auth, database, storage, ref, child, update, signOut, storageRef, uploadBytes, getDownloadURL, EmailAuthProvider, reauthenticateWithCredential, updatePassword } from '../../firebase'
import withLayout from '../../withLayout'
import AuthUserContext from '../../AuthUserContext'
import { BtnPrimary } from '../commons/Buttons'
import { ControlInput } from '../commons/Controls'
import Dropzone from 'react-dropzone'

class Account extends Component {
  constructor (props) {
    super(props)
    this.state = {
      name: '',
      photoFile: null,
      oldPassword: '',
      passwordA: '',
      passwordB: '',
      error: null,
      saving: false,
      success: null
    }
    this.onSubmit = this.onSubmit.bind(this)
    this.changeName = this.changeName.bind(this)
    this.changePassword = this.changePassword.bind(this)
    this.changePhoto = this.changePhoto.bind(this)
  }
  onSubmit (id, modifyUser) {
    if (this.state.name === '') {
      this.errorMsg = 'Tu nombre no puede quedar vacío'
      this.setState({
        error: 'name'
      })
    } else if (this.state.passwordA !== this.state.passwordB) {
      this.errorMsg = 'Las contraseñas no coinciden'
      this.setState({
        error: 'password'
      })
    } else if (this.state.oldPassword === '' && this.state.passwordA) {
      this.errorMsg = 'Necesitas tu contraseña actual para hacer el cambio'
      this.setState({
        error: 'oldPassword'
      })
    } else {
      this.setState({
        saving: true
      })
      this.changeName(id, modifyUser)
        .then(() => {
          return this.changePassword()
        })
        .then(() => {
          return this.changePhoto(id)
        })
        .then((photoUrl) => {
          this.setState({ saving: false, success: true })
          setTimeout(() => modifyUser(this.state.name, photoUrl || null), 3000)
        })
        .catch((err) => {
          console.log(err)
          this.errorMsg = err.message
          this.setState({
            saving: false,
            error: true
          })
        })
    }
  }
  changeName (id, modifyUser) {
    return new Promise((resolve, reject) => {
      if (this.state.name) {
        update(child(ref(database, 'usuarios/index'), id), { name: this.state.name })
          .then(() => {
            resolve()
          })
          .catch((err) => {
            reject(err)
          })
      } else {
        resolve()
      }
    })
  }
  changePassword () {
    return new Promise((resolve, reject) => {
      if (this.state.passwordB) {
        const user = auth.currentUser
        const credential = EmailAuthProvider.credential(user.email, this.state.oldPassword)
        reauthenticateWithCredential(user, credential)
          .then(() => {
            return updatePassword(user, this.state.passwordB)
          })
          .then(() => {
            resolve()
          })
          .catch((err) => {
            reject(err)
          })
      } else {
        resolve()
      }
    })
  }
  changePhoto (id) {
    return new Promise((resolve, reject) => {
      if (this.state.photoFile) {
        this.state.photoFile.toBlob((blob) => {
          let photoUrl
          const avatarRef = storageRef(storage, 'usuarios/avatars/' + id + '.jpg')
          uploadBytes(avatarRef, blob)
            .then((snap) => {
              return getDownloadURL(storageRef(storage, snap.metadata.fullPath))
            })
            .then((url) => {
              photoUrl = url
              return update(child(ref(database, 'usuarios/index'), id), { photo: url })
            })
            .then(() => resolve(photoUrl))
            .catch((err) => reject(err))
        }, 'image/jpeg', 0.6)
      } else {
        resolve()
      }
    })
  }
  handleLogout (ev) {
    ev.preventDefault()
    signOut(auth)
  }
  render () {
    return (
      <AuthUserContext.Consumer>
        {({ user, modifyUser }) => (
          <div className='account'>
            <div className='account__header'>
              <AccountPhoto
                onChange={(file) => this.setState({ photoFile: file })}
                current={user.photo}
              />
              <div className='account__email'>{user.email}</div>
            </div>
            <div className='account__form'>
              <AccountName
                onChange={(val) => this.setState({ name: val, error: null })}
                error={this.state.error === 'name'}
                current={user.name}
              />
              { user.provider === 'password' ? <div>
                <h3>Cambiar contraseña</h3>
                <ControlInput
                  label='Contraseña actual'
                  type='password'
                  value={this.state.oldPassword}
                  placeholder='Contraseña'
                  onChange={(ev) => this.setState({ oldPassword: ev.target.value, error: null })}
                  error={this.state.error === 'oldPassword'}
                />
                <ControlInput
                  label='Nueva contraseña'
                  type='password'
                  value={this.state.passwordA}
                  placeholder='Contraseña'
                  onChange={(ev) => this.setState({ passwordA: ev.target.value, error: null })}
                  error={this.state.error === 'password'}
                />
                <ControlInput
                  label='Confirmar nueva contraseña'
                  type='password'
                  value={this.state.passwordB}
                  placeholder='Contraseña'
                  onChange={(ev) => this.setState({ passwordB: ev.target.value, error: null })}
                  error={this.state.error === 'password'}
                />
              </div> : null }
              {this.state.error && <div className='error'>{this.errorMsg}</div>}
              {this.state.success && <div className='success'>Tus cambios se han guardado correctamente</div>}
              <BtnPrimary type='button' onClick={() => this.onSubmit(user.id, modifyUser)} disabled={this.state.saving}>Guardar cambios</BtnPrimary>
              <a className='account__logout' href='#logout' onClick={this.handleLogout}>Cerrar sesión</a>
            </div>
          </div>
        )}
      </AuthUserContext.Consumer>
    )
  }
}

class AccountName extends Component {
  constructor (props) {
    super(props)
    this.state = {
      name: props.current
    }
    props.onChange(props.current)
    this.onChange = this.onChange.bind(this)
  }
  onChange (ev) {
    this.setState({
      name: ev.target.value
    })
    this.props.onChange(ev.target.value)
  }
  render () {
    return (
      <ControlInput
        label='Nombre'
        type='text'
        value={this.state.name}
        placeholder='Nombre Apellido'
        onChange={this.onChange}
        error={this.props.error}
      />
    )
  }
}

class AccountPhoto extends Component {
  constructor (props) {
    super(props)
    this.state = {
      file: null
    }
    this.handleFile = this.handleFile.bind(this)
  }
  handleFile (file) {
    // Create preview URL for the file
    const fileWithPreview = file.map(f => Object.assign(f, {
      preview: URL.createObjectURL(f)
    }))
    
    this.setState({
      file: fileWithPreview
    })
    const image = new Image()
    const ctx = this.canvas.getContext('2d')
    image.onload = function () {
      let width = image.width
      let height = image.height
      let ratio = height / width
      let newHeight = 400
      let newWidth = Math.round(newHeight / ratio)
      let xPos = (newWidth - 400) / -2
      ctx.drawImage(image, xPos, 0, newWidth, newHeight)
    }
    image.src = fileWithPreview[0].preview
    this.props.onChange(this.canvas)
  }
  render () {
    return (
      <Dropzone
        multiple={false}
        accept={{
          'image/png': ['.png'],
          'image/jpeg': ['.jpg', '.jpeg']
        }}
        onDropAccepted={this.handleFile}>
        {({getRootProps, getInputProps}) => (
          <div {...getRootProps()} className='account__photo'>
            <input {...getInputProps()} />
            <div className='account__photo__overlay'>Modificar</div>
            {this.state.file ? <img src={this.state.file[0].preview} alt='Avatar' /> : <img src={this.props.current} alt='Avatar' />}
            <canvas width='400' height='400' style={{display: 'none'}} ref={(el) => { this.canvas = el }} />
          </div>
        )}
      </Dropzone>
    )
  }
}

export default withLayout(Account, null)
